














































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import { TableStripe } from '@/mixins/tableStripe';
import { performanceServer } from '@/api/installServer';

import RectifyFormDetail from './rectifyDetail.vue';
import ReviewList from '@/views/inspectionContents/rectificationNotice/reviewList.vue';
import DelayAuditList from '@/views/inspectionContents/rectificationNotice/delayUnit/delayAuditList.vue';

@Component({
  components: {
    PagingUnit,
    CollapseTransition,
    RectifyFormDetail,
    ReviewList,
    DelayAuditList,
  },
  mixins: [TableStripe],
})
export default class RectificationNotice extends Vue {
  flag = 1; // 控制显示的组件
  row: object = {}; // 传递一行的值

  oneColumnType = 'index'; // 决定第一列是索引还是选择
  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 1000; // 数据总共多少条
  searchFormData: any = {
    receiptCode: '',
    rectifyExpiryStartDate: '',
    rectifyExpiryEndDate: '',
    rectifyChargeStaffName: '',
    rectifyFormCreateStaffName: '',
  }; // 搜索栏的数据对象
  pageSearchData: any = {}; // 搜索栏的中间控制数据对象：当没有点 查询按钮时，这个值不会变
  tableData: Array<any> = []; // 表格的数据对象

  timeArr: any = [];
  radio1: any = '我整改的';
  // 整改单状态
  private rectifyStatus: any = {
    CREATED: '已创建',
    ISSUE: '已下发',
    RECTIFYING: '整改中',
    RECTIFIED: '已整改',
    FEEDBACK_ALREADY: '已反馈',
    FINISH: '已完成',
    REVIEW_FAIL: '复查不通过',
  };

  @Watch('radio1')
  private searchDept(val: any) {
    this.queryDataForm.pageNo = 1;
    if (val === '我整改的') {
      this.getReceiverListRectifyForm();
    } else {
      this.getSponsorListRectifyForm();
    }
  }

  created() {
    this.getReceiverListRectifyForm();
  }
  handleSearchDataFun() {
    if (this.timeArr) {
      this.searchFormData.rectifyExpiryStartDate = this.timeArr[0] ? this.timeArr[0] : null;
      this.searchFormData.rectifyExpiryEndDate = this.timeArr[1] ? this.timeArr[1] : null;
    } else {
      this.searchFormData.rectifyExpiryStartDate = null;
      this.searchFormData.rectifyExpiryEndDate = null;
    }
    const pageSearchData: any = {};
    for (const key in this.searchFormData) {
      if ((this.searchFormData as any)[key]) {
        // 如果搜索表单里面的这一项有值，那么就加入到 分页搜索数据中
        (pageSearchData as any)[key] = (this.searchFormData as any)[key];
      }
    }
    return pageSearchData;
  }
  getReceiverListRectifyForm() {
    const formData: any = this.handleSearchDataFun();
    performanceServer
      .receiverListRectifyForm({
        pageNo: this.queryDataForm.pageNo,
        pageSize: this.queryDataForm.pageSize,
        // rectifyFormCreateStaffName: this.searchFormData.rectifyFormCreateStaffName,
        ...formData,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.$message.error('获取设备数据失败');
      });
  }
  getSponsorListRectifyForm() {
    const formData: any = this.handleSearchDataFun();
    performanceServer
      .sponsorListRectifyForm({
        pageNo: this.queryDataForm.pageNo,
        pageSize: this.queryDataForm.pageSize,
        // rectifyChargeStaffName: this.searchFormData.rectifyChargeStaffName,
        ...formData,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        this.$message.error('获取设备数据失败');
      });
  }

  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    if (this.radio1 === '我整改的') {
      this.getReceiverListRectifyForm();
    } else {
      this.getSponsorListRectifyForm();
    }
  }
  searchData() {
    // 将 page 分页的页数重置为 1
    (this.queryDataForm as any).pageNo = 1;
    if (this.radio1 === '我整改的') {
      this.getReceiverListRectifyForm();
    } else {
      this.getSponsorListRectifyForm();
    }
  }

  /**
   * @desc 重置搜索的表单
   * @param1 暂无
   * @returns 暂无
   */
  resetSearch(): void {
    (this.$refs.formRef as any).resetFields(); // 重置表单内容
    this.timeArr = '';
    // this.radio1 = '我整改的';
    // this.searchFormData.receiptCode = '';
    // this.searchFormData.rectifyChargeStaffName = '';
    // this.searchFormData.rectifyFormCreateStaffName = '';
    // this.searchFormData.rectifyExpiryStartDate = '';
    // this.searchFormData.rectifyExpiryEndDate = '';
    (this.queryDataForm as any).pageNo = 1; // page 变为第一页 size 不变
    if (this.radio1 === '我整改的') {
      this.getReceiverListRectifyForm();
    } else {
      this.getSponsorListRectifyForm();
    }
  }
  reviewInfo(data: any) {
    const sendValue: any = {
      type: this.radio1,
      id: data.id,
    };
    this.row = sendValue;
    this.flag = 2;
  }
  backToTableList() {
    this.flag = 1;
    if (this.radio1 === '我整改的') {
      this.getReceiverListRectifyForm();
    } else {
      this.getSponsorListRectifyForm();
    }
  }
  jumpReviewList() {
    this.flag = 3;
  }
  jumpDelayAuditList() {
    this.flag = 4;
  }

  deleteHandle(data: any) {
    this.$confirm('确认要删除该数据吗？', '信息', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      customClass: 'box--msg',
    })
      .then(() => {
        performanceServer
          .deleteRectifyForm(data.id)
          .then((res: any) => {
            if (res.code === '200') {
              this.$message.success('删除成功!');
              if (this.radio1 === '我整改的') {
                this.getReceiverListRectifyForm();
              } else {
                this.getSponsorListRectifyForm();
              }
            } else {
              this.$message.warning(res.msg);
            }
          })
          .catch((error: any) => {
            this.$message.error('删除失败,请稍后重试!');
          });
      })
      .catch(() => {
        this.$message.info('已取消删除');
      });
  }
}
